import {
  AI_DETECTOR_TOOL_ID,
  AI_HUMANIZER_TOOL_ID,
  GRAMMAR_CHECK_TOOL_ID,
  PARAPHRASE_TOOL_ID,
  PLAGIARISM_TOOL_ID,
  SUMMARIZE_TOOL_ID,
} from '~/modules/tools/constants';

export const ExtensionOnboardingOldPath = '/onboarding-chrome-extension';
export const ExtensionOnboardingPath = '/onboarding-extension';

export const ExtensionPath = '/extension';

export const ExtensionOffboardingOldPath = '/offboarding-chrome-extension';
export const ExtensionOffboardingPath = '/offboarding-extension';

export const ExtensionAuthPath = '/sign-in-ext';

export const ExtensionSidebarKey = 'extension-sidebar';

export const ExtensionSidebarClickKey = 'extension-sidebar-click';

export const EXTENSION_POSSIBILITY_TOOL_ID: Record<
  string,
  'available' | 'soon'
> = {
  [GRAMMAR_CHECK_TOOL_ID]: 'available',
  [SUMMARIZE_TOOL_ID]: 'available',
  [PARAPHRASE_TOOL_ID]: 'available',
  [AI_DETECTOR_TOOL_ID]: 'soon',
  [AI_HUMANIZER_TOOL_ID]: 'soon',
  [PLAGIARISM_TOOL_ID]: 'soon',
};
